import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const RadioGroupRoot = styled.div`
  display: flex;
`;

const RadioGroup = ({name, selectedValue, onClickRadioButton, children, ...rest}) => {
  return (
    <RadioGroupRoot role="radiogroup" {...rest} name={name}>
      {React.Children.map(children, element =>{
        return React.cloneElement(element, {
          ...element.props,
          isSelected: selectedValue === element.props.value,
          onChange: () => onClickRadioButton(element.props.value),
          name
        })}
      )}
    </RadioGroupRoot>
  );
};

RadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string,
  onClickRadioButton: PropTypes.func,
  selectedValue: PropTypes.any
};

RadioGroup.defaultProps = {
  name: '',
  selectedValue: '',
};

export default RadioGroup;
